import React from 'react';
import classnames from 'classnames';
import { IMultiselectValueLabelPair } from "ui/Multiselect";
import { taskPriorities } from "./common";
import { TaskPriority } from "./TaskPriority";
import { ISingleSelectOption } from 'ui/SingleSelect';
import { ETaskStatus } from 'services/TaskManagementApi/types/TaskManagementResponse';
import { SvgIcon } from 'ui/SvgIcon';
import CircleIcon from 'ui/Icons/tabler/circle.component.svg';

export const taskStatusOptions: IMultiselectValueLabelPair[] = [
  {
    value: ETaskStatus.BLOCKED,
    label: 'Blocked',
    iconHtml: <SvgIcon IconComponent={CircleIcon} className="w-3 h-3 fill-status-cancelled" />,
    iconAlign: 'end',
  },
  {
    value: ETaskStatus.BACKLOG,
    label: 'Backlog',
    iconHtml: <SvgIcon IconComponent={CircleIcon} className="w-3 h-3 fill-gray-100" />,
    iconAlign: 'end',
  },
  {
    value: ETaskStatus.TO_DO,
    label: 'To Do',
    iconHtml: <SvgIcon IconComponent={CircleIcon} className="w-3 h-3 fill-purple" />,
    iconAlign: 'end',
  },
  {
    value: ETaskStatus.IN_PROGRESS,
    label: 'In Progress',
    iconHtml: <SvgIcon IconComponent={CircleIcon} className="w-3 h-3 fill-status-enquiry" />,
    iconAlign: 'end',
  },
  {
    value: ETaskStatus.DONE,
    label: 'Done',
    iconHtml: <SvgIcon IconComponent={CircleIcon} className="w-3 h-3 fill-green-hard" />,
    iconAlign: 'end',
  },
];

export const taskPriorityOptions: ISingleSelectOption[] = taskPriorities.map(priority => ({
  value: priority.value,
  renderItem: (className?: string) => (
    <TaskPriority className={classnames(className, 'min-h-[33px]')} value={priority.value} />
  ),
}));
